import { CheckBox, CustomVideoPlayer, HideIcon, Move } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import { CheckNumberCont, DragCont, VideoItemCont } from './item.styles';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ReactPlayer from 'react-player';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAgencyTalentPermissionPayload } from 'shared/interfaces/IProfile';
interface Props {
  src: string;
  idx?: string;
  check?: boolean;
  checked?: boolean;
  checkReturn?: (id: string) => void;
  vid: any;
  handleAgencyTalentPermissions?: (payload: IAgencyTalentPermissionPayload) => void;
}
function VideoItem({ src, idx, check, checkReturn, checked, vid, handleAgencyTalentPermissions }: Props) {
  const sortable = useSortable({ id: vid.id });
  const { attributes, listeners, isDragging, setNodeRef, transform, transition } = sortable;
  const [show, setshow] = useState(false);
  const { width } = useWindowDimensions();
  const checkClick = (e: any) => {
    e.stopPropagation();

    if (handleAgencyTalentPermissions) {
      handleAgencyTalentPermissions({
        module: 'videos',
        callback: () => {
          if (checkReturn) checkReturn(vid);
        },
        ctaText: 'OK',
      });
    }
  };

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform && { ...transform, scaleX: 1, scaleY: 1 }),
    transition,
    opacity: isDragging ? 0 : 1,
  };

  return (
    <VideoItemCont ref={setNodeRef} style={style} onMouseOver={() => setshow(true)} onMouseLeave={() => setshow(false)}>
      {check ? (
        <div style={{ position: 'absolute', top: -5, left: -5, zIndex: 10 }}>
          <CheckBox checked={checked} onClick={checkClick} />
        </div>
      ) : idx ? (
        <>
          {width > 960 ? (
            <CheckNumberCont style={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }} onClick={checkClick}>
              {show ? <HideIcon style={{ width: 18, height: 18, cursor: 'pointer' }} /> : idx}
            </CheckNumberCont>
          ) : (
            <>
              <CheckNumberCont style={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }} onClick={checkClick}>
                {idx}
              </CheckNumberCont>
              <CheckNumberCont style={{ position: 'absolute', top: 33, left: 5, zIndex: 2 }} onClick={checkClick}>
                <HideIcon style={{ width: 18, height: 18, cursor: 'pointer' }} />
              </CheckNumberCont>
            </>
          )}
        </>
      ) : (
        <></>
      )}
      {!check && (show || width < 960) && (
        <DragCont {...attributes} {...listeners} className="img-item-hover">
          <Move viewBox="0 0 16 16" style={{ width: 18, height: 18 }} />
          {/* <DragIcon /> */}
        </DragCont>
      )}
      <div style={{ flex: 1, height: '100%', borderRadius: 10, boxShadow: '0 0 10px 0 #2d343e' }}>
        <CustomVideoPlayer classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }} url={src} isSmall />
      </div>
    </VideoItemCont>
  );
}

export default VideoItem;
